import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BusinessEntityListResult,
  GetUserBusinessEntitiesOpts
} from '../interfaces/business-entity';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { BusinessEntity } from '../models/business-entity';

@Injectable({
  providedIn: 'root'
})
export class BusinessEntityControllerService {
  constructor(private readonly http: HttpClient) {}

  public getBusinessEntities(
    opts: GetUserBusinessEntitiesOpts
  ): Observable<BusinessEntityListResult> {
    if (!opts.order_by) {
      opts.order_by = 'created_at';
    }
    let url =
      environment.BASE_API_URL + 'businessentity?ordering=' + opts.order_by;
    if (opts.page) {
      url += '&page=' + opts.page;
    } else {
      url += '&super_size_me=100000';
    }
    if (opts.skip_files) {
      url += '&skip_files=1';
    }
    return this.http.get(url) as Observable<BusinessEntityListResult>;
  }

  public getBusinessEntity(id: string, opts?: { skip_files: boolean }) {
    let url = `${environment.BASE_API_URL}businessentity/${id}`;
    if (opts?.skip_files) {
      url += '?skip_files=1';
    }
    return this.http.get<BusinessEntity>(url);
  }

  public updateBusinessEntity(
    businessEntity: BusinessEntity,
    opts?: { withUsers: boolean }
  ) {
    const businessEntityData = JSON.parse(JSON.stringify(businessEntity));
    // Additional backend checks will attempt to look for has_root user in the given dataset.
    // When they do not find it, they return 400, hence we bypass this check here
    if (!opts?.withUsers) {
      delete businessEntityData.users;
    }
    let url = `${environment.BASE_API_URL}businessentity/${businessEntity.business_entity_id}`;
    return this.http.put(url, businessEntityData);
  }
}
